import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { GameCard } from '../components/GameCard';
import { gameProjects } from '../data/games';

export function renderGamesPage(): string {
  const engineCards = gameProjects.filter(g => g.category === 'Game Engine' || g.category === 'Open Source Tool').map(g => GameCard(g)).join('');
  const gameCards = gameProjects.filter(g => g.category === 'Steam Game' || g.category === 'Mobile Game').map(g => GameCard(g)).join('');

  return /*html*/`
    ${Header()}
    
    <main class="fade-in">
      <!-- Games Hero Header -->
      <section style="position: relative; padding: 5rem 0 4rem; overflow: hidden; background: radial-gradient(circle at 50% 20%, rgba(6, 214, 160, 0.15) 0%, rgba(7, 8, 13, 0.95) 75%); border-bottom: 1px solid rgba(6, 214, 160, 0.2);">
        <div style="position: absolute; inset: 0; opacity: 0.18; pointer-events: none;">
          <img src="/images/brand/atomix-game-banner.jpg" alt="AtomixGame Showcase" style="width: 100%; height: 100%; object-fit: cover;" />
        </div>
        
        <div class="container" style="position: relative; z-index: 1; text-align: center; max-width: 850px;">
          <div class="badge badge-green" style="margin-bottom: 1rem;">
            <sl-icon name="controller"></sl-icon>
            <span>AtomixGame Division</span>
          </div>
          <h1 style="font-size: clamp(2.2rem, 5vw, 3.5rem); margin-bottom: 1.25rem;">
            Open-Source Engines & <span class="text-gradient-green">Next-Gen Games</span>
          </h1>
          <p style="font-size: 1.15rem; color: #cbd5e1; line-height: 1.6; margin-bottom: 2rem;">
            Developing modular 3D/2D game frameworks, high-performance rendering engines (Atom3D, AtomGdx, AtomixGameEngine), and publishing original indie titles to Steam and App Store.
          </p>

          <div style="display: flex; justify-content: center; gap: 1rem; flex-wrap: wrap;">
            <a href="https://github.com/atomixgame" target="_blank" rel="noopener noreferrer" class="btn-cyber" style="background: linear-gradient(135deg, #0575e6 0%, #00f260 100%);">
              <sl-icon name="github"></sl-icon>
              <span>GitHub Organization (@atomixgame)</span>
            </a>
            <a href="https://store.steampowered.com/" target="_blank" rel="noopener noreferrer" class="btn-ghost">
              <sl-icon name="steam"></sl-icon>
              <span>Steam Publisher Page</span>
            </a>
          </div>
        </div>
      </section>

      <!-- Engines & Open Source Frameworks Section -->
      <section class="container" style="padding: 4.5rem 1.5rem;">
        <div class="section-header" style="text-align: left; margin-bottom: 2.5rem;">
          <span class="badge badge-green" style="margin-bottom: 0.5rem;">Frameworks & Architecture</span>
          <h2 style="font-size: 2rem;">Open-Source Game Engines</h2>
          <p style="margin: 0;">High performance, cache-friendly ECS pipelines, cross-platform renderers, and modern graphics shaders.</p>
        </div>
        <div class="grid grid-3">
          ${engineCards}
        </div>
      </section>

      <!-- Published Games & Mobile Releases -->
      <section style="background: rgba(6, 214, 160, 0.02); border-top: 1px solid rgba(255,255,255,0.06); padding: 4.5rem 0;">
        <div class="container">
          <div class="section-header" style="text-align: left; margin-bottom: 2.5rem;">
            <span class="badge badge-cyan" style="margin-bottom: 0.5rem;">Steam & App Store</span>
            <h2 style="font-size: 2rem;">Indie Titles & Commercial Releases</h2>
            <p style="margin: 0;">Original games crafted with procedural audio, custom shaders, and responsive physics.</p>
          </div>
          <div class="grid grid-2">
            ${gameCards}
          </div>
        </div>
      </section>

      <!-- Tech Architecture Callout -->
      <section class="container" style="padding: 4.5rem 1.5rem;">
        <div class="glass-panel" style="padding: 2.5rem; text-align: center; max-width: 900px; margin: 0 auto; border-left: 4px solid #06d6a0;">
          <h3 style="font-size: 1.6rem; color: #fff; margin-bottom: 1rem;">Join the AtomixGame Open Source Community</h3>
          <p style="color: #94a3b8; line-height: 1.7; margin-bottom: 1.5rem;">
            All core engine tools, math libraries, shader graphs, and ECS modules are maintained transparently on GitHub. We invite game developers, graphics engineers, and students to build and contribute.
          </p>
          <a href="https://github.com/atomixgame" target="_blank" rel="noopener noreferrer" class="btn-cyber" style="background: linear-gradient(135deg, #0575e6 0%, #00f260 100%);">
            <sl-icon name="star-fill"></sl-icon>
            <span>Star & Fork on GitHub</span>
          </a>
        </div>
      </section>

    </main>

    ${Footer()}
  `;
}
